import React from "react";
import Localizer from "../../localization/Localizer";
import AlertSubscriptionManagement, {defaultComparer, IBaseAlertSubscriptionManagementProps} from "./AlertSubscriptionManagement";

const BatteryAlertSubscriptionManagement: React.FC<IBaseAlertSubscriptionManagementProps> = (props: IBaseAlertSubscriptionManagementProps) => {
    return (
        <AlertSubscriptionManagement id="batteryCheckbox"
                                     label={Localizer.fleetMonitoringPageSubscribeToAlertsModalBatteryLow}
                                     description={Localizer.fleetMonitoringPageSubscribeToAlertsModalBatteryLowDescription}
                                     descriptionDataCy="battery-low-description"
                                     {...props}
        />
    );
};

export default React.memo(BatteryAlertSubscriptionManagement, defaultComparer);